<template>
  <div class="app">
    <MainHeader />
    <div class="app-body">
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <MainFooter />
  </div>
</template>

<script>
import { Breadcrumb } from '@coreui/vue'
import MainHeader from '../views/coreui/MainHeader'
import MainFooter from '../views/coreui/MainFooter'

export default {
  name: 'DefaultContainer',
  components: {
    Breadcrumb,
    MainHeader,
    MainFooter
  },
  data () {
    return {
      // nav: nav.items,
      // nav: [],
      isDevelopMode: !(process.env.NODE_ENV === 'production'),

      isActiveFamilyAddress: false
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  },
  beforeCreate: function () {
    // if (!this.$session.exists() || !DevAuthorize.isLogined(this)) {
    //   this.$router.push('/login')
    // }
  },
  created: function() {
  },
  methods: {
  }
}
</script>


<style lang="css" scoped>
.main > div.container-fluid {
  padding: 0 1rem;
}
</style>
<style lang="scss">
  // CoreUI Icons Set
  @import '~@coreui/icons/css/coreui-icons.min.css';

  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';

  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';

  /* Import Flag Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';

  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';

  // Import Main styles for this application
  @import '../assets/scss/style';
</style>

